import { AuthenticationErrorViewLegacy } from '@atlassian/jira-issue-view-errors';
import { connect } from '@atlassian/jira-issue-view-react-redux';
// this should be the last usage of this and can be cleaned up with isIssueViewRelayFragmentsAdoptionLeaderFlagEnabled()
import { login } from '@atlassian/jira-issue-view-store/src/actions/login-actions';

export default connect(null, {
	login,
})(AuthenticationErrorViewLegacy);
